import { oneSiam } from "./one-siam"

export const extensionConfigs = {
  "one-siam": oneSiam,
}
